import { useAppSelector } from './useAppSelector';

export default function useCanModifySkuChecker() {
  const user = useAppSelector((state) => state.user);
  return !!user.group?.modifySkuChecker;
}
